const XDAI_CHAINLINK_MAPPING = {
  // 1INCH / USD
  '0xFDF9EB5fafc11Efa65f6FD144898da39a7920Ae8': {
    from: '0x7f7440C5098462f833E123B44B8A03E1d9785BAb',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // AAVE / USD
  '0x2b481Dc923Aa050E009113Dca8dcb0daB4B68cDF': {
    from: '0xDF613aF6B44a31299E48131e9347F034347E2F00',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // ALPHA / USD
  '0x7969b8018928F3d9faaE9AC71744ed2C1486536F': {
    from: '0xD4576749f6cd3FA97F4De3eEeB9043f517468262',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // BAL / USD
  '0x1b723C855F7D2c2785F99486973271355e782d77': {
    from: '0x7eF541E2a22058048904fE5744f9c7E4C57AF717',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // BTC / USD
  '0x6C1d7e76EF7304a40e8456ce883BC56d3dEA3F7d': {
    from: '0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 8,
    toDecimals: 8,
  },
  // COMP  / USD
  '0xBa95Bc8418Ebcdf8a690924E1d4aD5292139F2EA': {
    from: '0xDf6FF92bfDC1e8bE45177DC1f4845d391D3ad8fD',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // CREAM  / USD
  '0x3b681e9BF56eFe4b2a14196826230A5843fFF758': {
    from: '0x1939D3431CF0E44B1d63b86e2cE489E5a341B1Bf',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // CRV  / USD
  '0xC77B83ac3Dd2a761073bD0f281f7b880B2DDDe18': {
    from: '0x712b3d230F3C1c19db860d80619288b1F0BDd0Bd',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // DAI / USD
  '0x678df3415fc31947dA4324eC63212874be5a82f8': {
    from: '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // DOT / USD
  '0x3c30c5c415B2410326297F0f65f5Cbb32f3aefCc': {
    from: '0xe51Cf68301B30b06c72d38f5314FA85c94C8e5f1',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // DPI / USD
  '0x53B1b13E7a5C0DE9A2BeFa1085Ec364BB27e439f': {
    from: '0xD3D47d5578e55C880505dC40648F7F9307C3e7A8',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // ETH / USD
  '0xa767f745331D267c7751297D982b050c93985627': {
    from: '0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // FTT / USD
  '0x0CaE8f5c10931f0Ce87Ed9BbB71391C6E93C2C26': {
    from: '0x75886F00c1a20Ec1511111Fb4Ec3C51de65B1fe7',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // GRT / USD
  '0xeBbd67a84e33791F1bcFde74CDc22a71e332e2F1': {
    from: '0xFAdc59D012Ba3c110B08A15B7755A5cb7Cbe77D7',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // JPY / USD
  '0x2AfB993C670C01e9dA1550c58e8039C1D8b8A317': {
    from: '0x417602f4fbdd471A431Ae29fB5fe0A681964C11b',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // LINK / USD
  '0xed322A5ac55BAE091190dFf9066760b86751947B': {
    from: '0xE2e73A1c69ecF83F464EFCE6A5be353a37cA09b2',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // MKR / USD
  '0x51e4024255d0cBd1F4C79AEe6BDB6565Df2C5d1b': {
    from: '0x5fd896D248fbfa54d26855C267859eb1b4DAEe72',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // PERP / USD
  '0x76e76F7E73F3BD42E3c2b4282B50b36E78130B4A': {
    from: '0x7ecF26cd9A36990b8ea477853663092333f59979',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // REN / USD
  '0x27d4D36968a2BD1Cc3406D99cB1DF50561dBf2a4': {
    from: '0x0da1a02CDF84C44021671d183d616925164E08Aa',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // RUNE / USD
  '0x93e3510d9AF4cBac3Ff0EeD3bddb0f52cCE0Ef15': {
    from: '0x4c68041898bfEfbfCc4253fbE8eD30830E6eb767',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // SNX / USD
  '0x3b84d6e6976D5826500572600eB44f9f1753827b': {
    from: '0x3A00E08544d589E19a8e7D97D0294331341cdBF6',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // STAKE / USD
  '0x55f4b2D20d447dB498bCCCde60Fa9a51a3df6D72': {
    from: '0xb7D311E2Eb55F2f68a9440da38e7989210b9A05e',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // SUSHI / USD
  '0xC0a6Bf8d5D408B091D022C3C0653d4056D4B9c01': {
    from: '0x2995D1317DcD4f0aB89f4AE60F3f020A4F17C7CE',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // UMA / USD
  '0xF826E3ff8c0481D2e58DB9d301936F94Cd4fa916': {
    from: '0x5806212Bec491bEb309E3F5C1F911eaC6f24cd6b',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // UNI / USD
  '0xd98735d78266c62277Bb4dBf3e3bCdd3694782F4': {
    from: '0x4537e328Bf7e4eFA29D05CAeA260D7fE26af9D74',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // USDC / USD
  '0x26C31ac71010aF62E6B486D1132E266D6298857D': {
    from: '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 6,
    toDecimals: 8,
  },
  // YFI / USD
  '0x14030d5a0C9e63D9606C6f2c8771Fc95b34b07e0': {
    from: '0xbf65bfcb5da067446CeE6A706ba3Fe2fB1a9fdFd',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
}

export default XDAI_CHAINLINK_MAPPING
